import React from "react";
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from "react-router-dom";

import Admindashboard from "./components/Admin/admindashboard";
import EducationGroup from "./components/Admin/Users_Group/Education_Group";
import MotherTongue from "./components/Admin/Users_Group/Mother_Tongue";
import IncomeGroup from "./components/Admin/Users_Group/Income_Group";
import CityGroup from "./components/Admin/Users_Group/City_Group";
import StateGroup from "./components/Admin/Users_Group/State_Group";
import CountryGroup from "./components/Admin/Users_Group/Country_Group";
import ReligionGroup from "./components/Admin/Users_Group/Religion_Group";
import CastGroup from "./components/Admin/Users_Group/Cast_Group";
import GothraGroup from "./components/Admin/Users_Group/Gothra_Group";
import PropertyType from "./components/Admin/Users_Group/Property_Type";
import ResidenceType from "./components/Admin/Users_Group/Residence_Type";
import EducationSpecialization from "./components/Admin/Users_Group/Education_Specialization";
import Occupation from "./components/Admin/Users_Group/Occupation";
import OccupationFunctionalArea from "./components/Admin/Users_Group/Occupation_Functional_Area";
import OccupationRole from "./components/Admin/Users_Group/Occupation_Role";
import VerifyUserEmail from "./components/Admin/Users_Group/Verify_User_Email";
import VerifyMspEmail from "./components/Admin/Users_Group/Verify_Msp_Email";
import Msp from "./components/Admin/Users_Data/Msp";
import MspVideo from "./components/Admin/Other_Forms/Msp_Video";
import MspGallary from "./components/Admin/Other_Forms/Msp_Gallary";
import MspEventImage from "./components/Admin/Other_Forms/Msp_Event_Image";
import MspHeaderText from "./components/Admin/Other_Forms/Msp_Header_Text";
import WonderfulWeddingPlanners from "./components/Admin/Wedding_Friends/Wonderful_Wedding_Planners";
import VideoPhotography from "./components/Admin/Wedding_Friends/Video_Photography";
import LovelyWeddingLocation from "./components/Admin/Wedding_Friends/Lovely_Wedding_Location";
import FabulousFlorals from "./components/Admin/Wedding_Friends/Fabulous_Florals";
import CreativeCatering from "./components/Admin/Wedding_Friends/Creative_Catering";
import Musicians from "./components/Admin/Wedding_Friends/Musicians";
import DressMaterials from "./components/Admin/Wedding_Friends/Dress_Materials";
import EventProduction from "./components/Admin/Wedding_Friends/Event_Production";
import Jwellers from "./components/Admin/Wedding_Friends/Jwellers";
import SignIn from "./components/other component/signin";
import ProtectedRoute from "./components/other component/protected_route";
import SubAdmin from "./components/Admin/SubAdmin/create_subadmin";
import PaymentDetails from "./components/Admin/PaymentDetails/payment";
import PropertySize from "./components/Admin/Users_Group/property_size";
import FindMatches from "./components/Admin/Matches/find_matches";
import CommunityGroup from "./components/Admin/Users_Group/community_group";
import Allprofiles from "./components/Admin/All_Profiles/view_all_profile";
import Editprofile from "./components/Admin/All_Profiles/edit_profile";
import AddBlog from "./components/Admin/Blog/add_blog";
import RecycleBin from "./components/Admin/RecycleBin/recycle_bin_profile";
import Settings  from "./components/Admin/Settings/settings";
import AddFeedback from "./components/Admin/Feedback/feedback";
import MspProfiles from "./components/Admin/Users_Data/msp_profiles";
import UserProfile from "./components/Admin/Users_Data/user_profile";
import Joinnow from "./components/Admin/Join_Now/join_now";
import ContactUs from "./components/Admin/ContactUs/contact_us";
import NewProfileForm from "./components/Admin/Users_Data/edit_user_profile";
import MatchesPage from "./components/Admin/MatchedProfiles/matched_profile";



function App() {
  return (
   
    <BrowserRouter>
      <Routes>
         <Route path="/" element={<SignIn/>}></Route>
    
      <Route element={<ProtectedRoute />}>
        <Route path="/admin-dashboard" element={<Admindashboard/>}></Route>
        {/*==================== user Group section ==================================*/}

        <Route path="/education-group" element={<EducationGroup/>}></Route>
        <Route path="/income-group" element={<IncomeGroup/>}></Route>
        <Route path="/city-group" element={<CityGroup/>}></Route>
        <Route path="/state-group" element={<StateGroup/>}></Route>
        <Route path="/country-group" element={<CountryGroup/>}></Route>
        <Route path="/religion-group" element={<ReligionGroup/>}></Route>
        <Route path="/community-group" element={<CommunityGroup/>}></Route>
        <Route path="/cast-group" element={<CastGroup/>}></Route>
        <Route path="/gothra-group" element={<GothraGroup/>}></Route>
        <Route path="/property-type" element={<PropertyType/>}></Route>
        <Route path="/property-size" element={<PropertySize/>}></Route>
        <Route path="/residence-type" element={<ResidenceType/>}></Route>
        <Route path="/mother-tongue" element={<MotherTongue/>}></Route>
        <Route path="/education-specialization" element={<EducationSpecialization/>}></Route>
        <Route path="/occupation" element={<Occupation/>}></Route>
        <Route path="/occupation-functional-area" element={<OccupationFunctionalArea/>}></Route>
        <Route path="/occupation-role" element={<OccupationRole/>}></Route>
        <Route path="/verify-user-email" element={<VerifyUserEmail/>}></Route>
        <Route path="/verify-msp-email" element={<VerifyMspEmail/>}></Route>
        
        {/*===================== user group section route end ===========================*/}

      {/* ======================Wedding Friends section routes start ====================*/}

      <Route path="/wonderfull-wedding-planners" element={<WonderfulWeddingPlanners/>}></Route>
      <Route path="/video-photography" element={<VideoPhotography/>}></Route>
      <Route path="/weddeing-location" element={<LovelyWeddingLocation/>}></Route>
      <Route path="/fabulous-florals" element={<FabulousFlorals/>}></Route>
      <Route path="/creative-catering" element={<CreativeCatering/>}></Route>
      <Route path="/musicians" element={<Musicians/>}></Route>
      <Route path="/dress-material" element={<DressMaterials/>}></Route>
      <Route path="/event-production" element={<EventProduction/>}></Route>
      <Route path="/jwellers" element={<Jwellers/>}></Route>

      {/* ======================Wedding Friends section routes end ====================*/}


      {/*===================== users data section route start ===========================*/}

       <Route path="/msp" element={<Msp/>}></Route>
       <Route path="/msp-profiles" element={<MspProfiles/>}></Route>
       <Route path="/user-profile" element={<UserProfile/>}></Route>
       <Route path="/update-user-profile" element={<NewProfileForm/>}></Route>

      {/*===================== users data section route end ===========================*/}

      {/*===================== create sub-admin route start ===========================*/}

       <Route path="/sub-admin" element={<SubAdmin/>}></Route>

      {/*===================== create sub-admin route end ===========================*/}

           {/*===================== create matches route start ===========================*/}

       <Route path="/matches" element={<MatchesPage/>}></Route>

      {/*===================== create matches route end ===========================*/}

      {/*=============================== other routes start============================ */}

        <Route path="/msp-video" element={<MspVideo/>}></Route>
        <Route path="/msp-gallary" element={<MspGallary/>}></Route>
        <Route path="/msp-event-image" element={<MspEventImage/>}></Route>
        <Route path="/msp-header-text" element={<MspHeaderText/>}></Route>

      {/*============================== other routes end==================================== */}

      {/*=============================== payment routes start============================ */}

        <Route path="/payment-details" element={<PaymentDetails/>}></Route>

      {/*============================== payment routes end==================================== */}

        {/*=============================== matches routes start============================ */}

        <Route path="/find-matches" element={<FindMatches/>}></Route>

      {/*============================== matches routes end==================================== */}

      {/*=============================== view all profile routes start============================ */}

        <Route path="/view-profiles" element={<Allprofiles/>}></Route>
        <Route path="/edit-profile" element={<Editprofile/>}></Route>

      {/*============================== view all profile routes end==================================== */}

      {/*=============================== view all profile routes start============================ */}

        <Route path="/add-blog" element={<AddBlog/>}></Route>

      {/*============================== Recycle Bin profile routes end==================================== */}

            {/*=============================== view all profile routes start============================ */}

        <Route path="/recycle-bin" element={<RecycleBin/>}></Route>

      {/*============================== Recycle Bin profile routes end==================================== */}

      {/*=============================== settings routes start============================ */}

        <Route path="/settings" element={<Settings/>}></Route>

      {/*============================== settings routes end==================================== */}

       {/*=============================== feedback routes start============================ */}

        <Route path="/feedback" element={<AddFeedback/>}></Route>

      {/*============================== feedback routes end==================================== */}
      {/*=============================== contact us routes start============================ */}
        <Route path="/contactus" element={<ContactUs/>}></Route>

        <Route path="/join-now" element={<Joinnow/>}></Route>

      {/*============================== contact us routes end==================================== */}

    </Route>

      </Routes>
   
      
        
    </BrowserRouter>

   
  );
}

export default App;
